import { render, staticRenderFns } from "./LocaleModal.vue?vue&type=template&id=57d2b6e6&scoped=true&"
import script from "./LocaleModal.vue?vue&type=script&lang=js&"
export * from "./LocaleModal.vue?vue&type=script&lang=js&"
import style0 from "./LocaleModal.vue?vue&type=style&index=0&id=57d2b6e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2b6e6",
  null
  
)

export default component.exports